import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { ApiResponse } from "@/utils/ApiResponse";
import { ProductoInterface } from "../../interfaces/productoInterfaces/Producto.interface";
import { useToast } from "vue-toastification";
import { DeleteProductoAction } from "../../actions/productoActions";
import { invalidateDashboardQueries } from "@/utils/helper/invalidateDashboard";

const toast = useToast();

export function useProductoDelete(onClose?: () => void) {
  const queryClient = useQueryClient();

  // Mutation para eliminar un producto
  const mutation = useMutation({
    mutationFn: (productoId: string) => DeleteProductoAction(productoId),

    onSuccess:async (response: ApiResponse<ProductoInterface>) => {
      await queryClient.invalidateQueries({ queryKey: ["ProductosList"] });
      toast.success("El producto fue eliminado correctamente");
        // âœ… Invalidar todo el dashboard
      await invalidateDashboardQueries(queryClient);
      if (onClose) onClose();
    },

    onError: (error: unknown) => {
      toast.error("Error al eliminar el producto");
        if (onClose) onClose();
    },
  });

  return {
    ...mutation, // => { mutate, mutateAsync, isPending, isError, error, isSuccess, data }
  };
}
